import {
  ListingTableMidHeader,
  TCol,
} from "../../../../components/layout/listing-table/listing-table.types";
import {
  Date,
  UserName,
} from "../../../../components/layout/listing-table/listing-table-render-components";

import { FlyerListTableOptionsMenu } from "../../components/flyer-list-table-options-menu/flyer-list-table-options-menu.component";

import { flyerStatus } from "./flyer-list-table.functions";

export const columnConfiguration: TCol[] = [
  { label: "Name", key: "name", headerVariant: "h5" },
  { label: "Owner", key: "owner", render: (row) => UserName(row.owner) },
  { label: "Start Date", key: "startDate", render: (row) => Date(row.startAt) },
  { label: "End Date", key: "endDate", render: (row) => Date(row.endAt) },
  {
    label: "Number of Pages",
    key: "pageCount",
  },
  {
    label: "Number of Positions",
    key: "positionCount",
  },
  {
    label: "Status",
    key: "paginationStatus",
    render: (row) => flyerStatus(row.paginationStatus),
  },
  {
    label: "",
    key: "",
    render: (row) =>
      row.completed ? <></> : <FlyerListTableOptionsMenu id={row.id} name={row.name} />,
    stopPropagation: true,
  },
];

export const completedLabel = "Completed";

export const completedHeaderRow = [
  {
    label: completedLabel,
    [ListingTableMidHeader]: true,
  },
];
